<template>
    <v-container style="position: relative">
        <v-tabs v-model="tab">
            <v-tab>Bidang Keahlian</v-tab>
            <v-tab>Indeks Kesulitan</v-tab>
            <v-tab>Event Try Out External</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <field-data></field-data>
            </v-tab-item>

            <v-tab-item>
                <difficulty-index-data></difficulty-index-data>
            </v-tab-item>
        </v-tabs-items>
    </v-container>
</template>

<script>
import FieldData from './FieldData.vue'
import DifficultyIndexData from './DifficultyIndexData.vue'

export default {
    components: {
        FieldData,
        DifficultyIndexData,
    },

    data: () => ({
        tab: null,
    }),
}
</script>
